




















import UserForm from '@/components/user/UserForm.vue';
import UserUtils, { User } from '@/utils/UserUtils';
import Vue from 'vue';

export default Vue.extend({
  components: { UserForm },

  data(): {
    state: {
      valid: boolean;
      submit: boolean;
      errors?: any[];
    };
    item?: Partial<User>;
  } {
    return {
      state: {
        valid: false,
        submit: false,
        errors: undefined,
      },
      item: undefined,
    };
  },

  async mounted() {
    this.item = UserUtils.generateDefault();
  },

  methods: {
    async handleSubmit() {
      if (this.item) {
        try {
          this.state.errors = undefined;
          this.state.submit = true;
          (this.$refs.form as any).validate();
          this.item = await UserUtils.api.create(this.item);
          (this.$refs.form as any).resetValidation();
          this.$toast.push({
            text: this.$t('success.create', [this.$tc('user.label')]),
            type: 'success',
          });
          this.$router.push(this.$route.meta.header.route);
        } catch (error: any) {
          this.$toast.push({
            text: this.$t('error.create', [this.$tc('user.label')]),
            type: 'error',
          });
          this.state.errors = error; // TODO: handle errors
        } finally {
          this.state.submit = false;
        }
      }
    },
  },
});
